var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21C5.468 21 1 16.532 1 11S5.468 1 11 1s10 4.468 10 10-4.468 10-10 10zm0-19.149c-5.043 0-9.149 4.106-9.149 9.149 0 5.043 4.106 9.149 9.149 9.149 5.043 0 9.149-4.106 9.149-9.149 0-5.043-4.106-9.149-9.149-9.149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.872 13.574a.427.427 0 01-.425-.425v-1.383c0-.213.149-.383.34-.426.085-.02 2.128-.425 2.277-2.234 0-1.106-.49-1.808-1.447-2.063-1.255-.34-2.447.212-2.83 1.34a.434.434 0 01-.553.255.417.417 0 01-.255-.553c.532-1.51 2.191-2.319 3.85-1.872 1.341.361 2.065 1.383 2.065 2.893v.043c-.128 1.745-1.617 2.638-2.639 2.936v1.043a.377.377 0 01-.383.446zm.085 3.32a.956.956 0 000-1.915.957.957 0 100 1.915z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.327bcfbf9c9997ee3e861f92c5823b63.svg";
export { ForwardRef as ReactComponent };